import { DiabeticFormEvaluator, diabeticFormQuestions } from "./ComposedDiabeticMedicalQuestions";
import {
  ComposedGeneralMedicalQuestions,
  GeneralMedicalQuestionsEvaluatorConfig
} from "./ComposedGeneralMedicalQuestions";
import { PacemakerFormEvaluator, pacemakerFormQuestions } from "./ComposedPacemakerMedicalQuestions";
import { RadiationFormEvaluator, radiationFormQuestions } from "./ComposedRadiationMedicalQuestions";
import IMedicalFormElement from "../Types/IMedicalFormElement";
import IMedicalQualification from "../Types/IMedicalQualification";

/** A single question entry in the sequential medical question list. */
export interface ISequencedMedicalQuestion {
  /** The question component to render. */
  Component: React.FC<IMedicalFormElement>;
  /** Returns true when enough answers have been given to advance past this question. */
  isComplete: (form: IMedicalQualification) => boolean;
}

/** Ordered sequence of all medical questions. The five general questions are individual entries;
 * the pacemaker, radiation, and diabetic groups are each a single entry that may expand inline. */
const MedicalQuestionSequence: ISequencedMedicalQuestion[] = [
  ...ComposedGeneralMedicalQuestions.map((Component, i) => ({
    Component,
    isComplete: (form: IMedicalQualification) =>
      form[GeneralMedicalQuestionsEvaluatorConfig.allFormQuestionIds[i]] != null
  })),
  {
    Component: pacemakerFormQuestions[0],
    isComplete: (form: IMedicalQualification) => PacemakerFormEvaluator.isComplete(form)
  },
  {
    Component: radiationFormQuestions[0],
    isComplete: (form: IMedicalQualification) => RadiationFormEvaluator.isComplete(form)
  },
  {
    Component: diabeticFormQuestions[0],
    isComplete: (form: IMedicalQualification) => DiabeticFormEvaluator.isComplete(form)
  }
];

export default MedicalQuestionSequence;
